import { Card, Tag } from 'antd';
import { Link } from 'react-router-dom';

import {
  orderTypeColors,
  orderTypeLabels,
} from 'apps/investment/constants/fundOrder';
import {
  programOrderMatchSourceCompanyPortfolio,
  programOrderStatusColors,
  programOrderTypeRedistribute,
} from 'apps/investment/constants/programOrder';
import { DataTable } from 'common/data-table';
import CashSVG from 'common/svg/cash-svg';
import InfoCard from 'common/ui/info-card';
import { Info } from 'lucide-react';
import { cn } from 'utils/cn';
import { formatCurrency, formatNumber } from 'utils/formatAmount';
import { formatDateTime } from 'utils/formatDate';
import {
  fundOrdersColumnsGenerator,
  stockOrdersColumnsGenerator,
} from './config';

const ItemDetail = ({ item }) => {
  const {
    order_id,
    status,
    status_label,
    order_type,
    product_code,
    order_side,
    quantity,
    matched_quantity,
    price,
    matched_price,
    amount,
    matched_amount,
    matched_source,
    user,
    stock_orders,
    fund_orders,
  } = item;

  let orderType = order_type;
  if (
    order_type == 'buy' &&
    matched_source == programOrderMatchSourceCompanyPortfolio
  ) {
    orderType = programOrderTypeRedistribute;
  }

  return (
    <div>
      <Card
        className={cn('my-4 shadow-md overflow-hidden border-2', {
          'border-green-500': orderType === 'buy',
          'border-blue-500': orderType === 'sell',
          'border-cyan-500': orderType === programOrderTypeRedistribute,
        })}
      >
        <div className="space-y-4">
          <div className="flex items-end gap-2">
            <Tag
              style={{
                fontSize: 'large',
                fontWeight: 'bold',
                padding: '8px',
              }}
              color={orderTypeColors[orderType]}
            >
              {orderTypeLabels[orderType]}
            </Tag>
            <Tag
              style={{
                fontSize: 'large',
                fontWeight: 'bold',
                padding: '8px',
              }}
              color={programOrderStatusColors[status]}
            >
              {status_label}
            </Tag>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <InfoCard label="Sản phẩm" value={product_code} />
          </div>

          <h3 className="text-base font-medium text-gray-800 pt-2 border-b flex items-center">
            <CashSVG className="mr-1" />
            Thông tin giao dịch
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <InfoCard
              className="text-right"
              label="Giá đặt"
              value={formatCurrency(price)}
            />
            <InfoCard
              className="text-right"
              label="Số lượng đặt"
              value={isNaN(quantity) ? '-' : formatNumber(quantity)}
            />
            <InfoCard
              className="text-right"
              label="Giá trị đặt"
              value={formatCurrency(amount)}
            />
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <InfoCard
              className="text-right"
              label="Giá khớp"
              value={formatCurrency(matched_price)}
            />
            <InfoCard
              className="text-right"
              label="Số lượng khớp"
              value={
                isNaN(matched_quantity) ? '-' : formatNumber(matched_quantity)
              }
            />
            <InfoCard
              className="text-right"
              label="Giá trị khớp"
              value={formatCurrency(matched_amount)}
            />
          </div>

          <h3 className="text-base font-medium text-gray-800 border-b pt-2 flex items-center">
            <Info className="text-primary size-5 mr-1" />
            Chi tiết lệnh
          </h3>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {user && (
              <InfoCard
                label="User"
                value={
                  <Link to={`/investment/users/${user.id}`}>
                    {user.email ?? ''}
                  </Link>
                }
              />
            )}
          </div>
        </div>
        <div className="bg-gray-50 bg- -mx-6 -mb-6 p-6 rounded-b-lg mt-4 space-y-4">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            <InfoCard
              label="Order Date"
              value={formatDateTime(item.order_date)}
            />
            <InfoCard
              label="Created At"
              value={formatDateTime(item.created_at)}
            />
            <InfoCard
              label="Updated At"
              value={formatDateTime(item.updated_at)}
            />
          </div>
        </div>
      </Card>

      {stock_orders?.length > 0 && (
        <Card className="my-4 shadow-md" title="Lệnh chứng khoán">
          <DataTable
            columns={stockOrdersColumnsGenerator()}
            data={stock_orders}
            tableName="stockOrdersOfOrders"
          />
        </Card>
      )}
      {fund_orders?.length > 0 && (
        <Card className="my-4 shadow-md" title="Lệnh chứng chỉ quỹ">
          <DataTable
            columns={fundOrdersColumnsGenerator()}
            data={fund_orders}
            tableName="fundOrdersOfOrders"
          />
        </Card>
      )}
    </div>
  );
};

export default ItemDetail;
